/** Shared React Flow canvas styling for the workflow builder. */
export const WORKFLOW_EDGE_OPTIONS = {
  type: "workflowDeletable",
  style: { strokeWidth: 2.5, stroke: "#94a3b8" },
  animated: true
};

export const WORKFLOW_CANVAS_CLASS = "bg-[#FAFAFA] dark:bg-slate-950 h-full w-full";

/** React Flow `<Background>` dot pattern (use with `useColorModeValue`). */
export const WORKFLOW_CANVAS_DOT_COLOR = {
  light: "#64748b",
  dark: "#94a3b8"
};

export const WORKFLOW_CANVAS_DOT_SIZE = 1.5;

/** Tailwind class bundles for workflow pages (light + dark). */
export const workflowTheme = {
  page: "min-h-full bg-slate-50 dark:bg-slate-950",
  /** Scrollable full-page shells (create wizard). */
  pageSolid: "min-h-full bg-white dark:bg-slate-950",
  /** Builder shell inside MenuLayout — no min-h-screen (use with h-full -m-3). */
  pageFill: "bg-white dark:bg-slate-950",
  surface: "bg-white dark:bg-slate-900",
  surfaceMuted: "bg-[#FAFAFA] dark:bg-slate-900",
  tabBar: "bg-white dark:bg-slate-900 border-gray-200 dark:border-slate-800",
  header: "bg-white dark:bg-slate-900 border-gray-200 dark:border-slate-800",
  card: "bg-white dark:bg-slate-900 border-gray-200 dark:border-slate-800",
  cardHover: "bg-white dark:bg-slate-900 border-gray-200 dark:border-slate-800 hover:border-[hsl(158,48%,36%)]/40 dark:hover:border-[hsl(158,48%,36%)]/50",
  input:
    "bg-gray-50 dark:bg-slate-950 border-gray-200 dark:border-slate-800 text-gray-900 dark:text-white placeholder:text-gray-400 dark:placeholder:text-gray-500",
  textPrimary: "text-gray-900 dark:text-white",
  textSecondary: "text-gray-500 dark:text-gray-400",
  textMuted: "text-gray-400 dark:text-gray-500",
  border: "border-gray-200 dark:border-slate-800",
  borderSubtle: "border-gray-100 dark:border-slate-800",
  tabActive: "border-[hsl(158,48%,36%)] text-[hsl(158,48%,32%)] dark:text-[hsl(158,45%,55%)]",
  tabInactive: "border-transparent text-gray-500 dark:text-gray-400 hover:text-gray-900 dark:hover:text-white",
  badgeLive: "bg-green-100 text-green-800 dark:bg-green-900/30 dark:text-green-400",
  badgeDraft: "bg-yellow-100 text-yellow-800 dark:bg-yellow-900/30 dark:text-yellow-400",
  controls:
    "bg-white dark:bg-slate-900 border-gray-200 dark:border-slate-800 shadow-sm rounded-lg overflow-hidden [&_button]:bg-white [&_button]:dark:bg-slate-800 [&_button]:border-gray-200 [&_button]:dark:border-slate-700 [&_button_svg]:fill-gray-600 [&_button_svg]:dark:fill-gray-300 [&_button:hover]:bg-gray-50 [&_button:hover]:dark:bg-slate-700",
  errorBanner: "bg-red-50 dark:bg-red-950/40 border-red-200 dark:border-red-900",
  errorTitle: "text-red-900 dark:text-red-200",
  errorText: "text-red-800 dark:text-red-300",
  aiBanner: "bg-[hsl(158,48%,36%)]/10 dark:bg-[hsl(158,48%,36%)]/15 border-[hsl(158,48%,36%)]/30 dark:border-[hsl(158,48%,36%)]/40 text-[hsl(158,48%,32%)] dark:text-[hsl(158,45%,55%)]",
  selectBrand: "border-[hsl(158,48%,36%)] bg-[hsl(158,48%,36%)]/10 dark:bg-[hsl(158,48%,36%)]/15 dark:border-[hsl(158,48%,36%)]/50 text-[hsl(158,48%,32%)] dark:text-[hsl(158,45%,55%)]",
  backIconButton:
    "text-gray-700 dark:text-gray-200 hover:text-gray-900 dark:hover:text-white hover:bg-gray-100 dark:hover:bg-slate-800",
  iconButton: "border-gray-200 dark:border-slate-700 bg-gray-50 dark:bg-slate-800 text-gray-600 dark:text-gray-300 hover:bg-red-50 dark:hover:bg-red-950/40 hover:text-red-600 dark:hover:text-red-400 hover:border-red-200 dark:hover:border-red-900",
  triggerButton: "border-gray-200 dark:border-slate-700 bg-gray-50 dark:bg-slate-800 text-[hsl(158,48%,32%)] dark:text-[hsl(158,45%,55%)] hover:bg-[hsl(158,48%,36%)]/10 dark:hover:bg-[hsl(158,48%,36%)]/15 hover:border-[hsl(158,48%,36%)] dark:hover:border-[hsl(158,48%,36%)] disabled:border-gray-200 dark:disabled:border-slate-700 disabled:bg-gray-100 dark:disabled:bg-slate-900 disabled:text-gray-400 dark:disabled:text-gray-500"
};
